var _defs, _g, _path, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 1.5px;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #928980;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #4cb0d3;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M76.9,39.1H3.1v19c0,1.8,1.4,3.2,3.2,3.2H73.7c1.8,0,3.2-1.4,3.2-3.2v-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3.3,36.1l.2,22.7,2.4,2.2H57.9l-1.6-2,.4-24.6-8.8-.5v21.1l-2.6,.5-32.9,.4-1.5-1.7,.1-19.2s-7.7,1.1-7.7,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M76.9,40.9H3.1V21.9c0-1.8,1.4-3.2,3.2-3.2H73.7c1.8,0,3.2,1.4,3.2,3.2v19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3.3,43.9l.2-22.7,2.4-2.2H57.9l-1.6,2,.4,24.6-8.8,.5V25l-2.6-.5-32.9-.4-1.5,1.7,.1,19.2s-7.7-1.1-7.7-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.5,61.5l-1.7,3.8c-.7,1.5-2.4,2.1-3.9,1.5l-.4-.2,2.4-5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.5,18.5l-1.7-3.8c-.7-1.5-2.4-2.1-3.9-1.5l-.4,.2,2.4,5.3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.29,18.9V60.9m0-42l-9.5,5.5m9.5-5.5h-3.5m3.5,0h.5m-.5,42l-9.5-5.83m9.5,5.83h-3.5m3.5,0h.5M4.29,19.9l-1,1V58.9l1,1m0-40l1-1H29.04m-24.75,1l6.5,4.5m0,0v31m0-31H29.04m18.25,31V24.4h-.5m.5,31H29.04m-18.25,0H29.04m-18.25,0l-6.5,4.5M29.04,24.4v-5.5m0,5.5h17.75m-17.75-5.5h23.75M29.04,55.4v5.5m0,0H5.29l-1-1m24.75,1h23.75m3.95-.52l-1.78,6.15-2.46,1.42-2.24-.75,2.31-6.22m4.22-42.08h17l2.5,2v2m-19.5,38h17l2.5-2v-2m0,0v-7m0,0V29.9m0,0v-7m-24.44-3.88l-2.31-6.22,2.24-.75,2.46,1.42,1.78,6.15"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 76.86,
    y: 25.2,
    width: 0.84,
    height: 5.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 76.86,
    y: 49.4,
    width: 0.84,
    height: 5.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.1c00ccf9855a35aea99a87a73c941b11.svg";
export { ForwardRef as ReactComponent };